import * as React from "react";
import { FormControl } from "react-bootstrap";
export class TextFilterComponent extends React.Component {
    render() {
        let { filter } = this.props;
        if (typeof filter !== "string") {
            filter = undefined;
        }
        return (React.createElement(FormControl, { className: "form-field-compact", type: "text", value: filter || "", onChange: this.changeFilter, inputRef: this.props.domRef }));
    }
    changeFilter = (evt) => {
        const { attributeId, onSetFilter } = this.props;
        onSetFilter(attributeId, evt.currentTarget.value);
    };
}
class TextFilter {
    component = TextFilterComponent;
    raw = false;
    mCaseInsensitive;
    constructor(ignoreCase) {
        this.mCaseInsensitive = ignoreCase;
    }
    matches(filter, value) {
        if (typeof filter !== "string") {
            // filter of the wrong type doesn't filter at all
            return true;
        }
        if (typeof value !== "string") {
            return false;
        }
        if (this.mCaseInsensitive) {
            if (value === undefined || filter === undefined) {
                return false;
            }
            return value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
        }
        else {
            return value.indexOf(filter) !== -1;
        }
    }
}
export default TextFilter;
